var v1="<div class=\"recommend-modal\"><div class=\"modal-header\"><button type=\"button\" data-bs-dismiss=\"modal\" aria-label=\"Close\" ng-click=\"cancel()\" class=\"close\"><span aria-hidden=\"true\">&times;</span></button><div class=\"message-content\">{{:: '_RECOMMEND.USE_PC' | translate }}</div></div></div>";
window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("components/modal/recommend-pc-modal.jade", v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./ngapp/javascript/web/components/modal/recommend-pc-modal.jade
// module id = 420
// module chunks = 0